module.exports = __webpack_public_path__ + "static/media/ic_file_download_white_24px.4b5c054e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic_file_download_white_24px.svg
// module id = 791
// module chunks = 0